import { createSlice } from '@reduxjs/toolkit';

import { IBlogsData } from 'shared/types/blogs';

const initialState: IBlogsData = {
  blogs: [],
  totalCount: 0,
  link: '',
};

const blogsSlice = createSlice({
  name: 'blogs',
  initialState,
  reducers: {},
  selectors: {
    selectBlogs: state => state,
  },
});

export const {
  reducer: blogsReducer,
  actions: {},
  selectors: { selectBlogs },
} = blogsSlice;
